<template>
  <div class="processing-payment">
    <div class="gradient-panel">
      <div class="content-area">
        <sending-payment></sending-payment>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import SendingPayment from '@/components/shared/SendingPayment';

// Utils
import { mapState } from 'vuex';

export default {
  name: 'ProcessingPayment',
  components: {
    SendingPayment
  },
  computed: {
    ...mapState(['insuranceType'])
  },
  async created() {
    window.scrollTo(0, 0);
    // Rehydrating the Vuex store and removing data from sessionStorage
    this.$store.dispatch('UPDATE_STATE')
    .then(() => {
      // Wait until medi-payment has responded with updated payment resource
      // Attempt to complete payment
      this.$store.dispatch('UPDATE_PAYMENT_RESOURCE_SUBMITTED')
      .then(() => {
        // Payment successful
        // Head to confirmation page
        if (this.$route.query.ins) {
          this.$router.push({ name: 'confirmation', query: {ins: this.insuranceType.key} });
        } else {
          this.$router.push('confirmation');
        }
      })
      .catch(() => {
        // Payment unsuccessful (failed)
        // Head to error page
        if (this.$route.query.ins) {
          this.$router.push({ name: 'error', query: {ins: this.insuranceType.key} });
        } else {
          this.$router.push('error');
        }
      });
    })
    .catch(() => {
      // If no data exists in the Vuex store, the user arrived at the ProcessingPayment page in error
      // Route the user to the Find Your Bill page to start the payment process over again.

      this.$store.commit('RESET_STATE');

      // Using this.$router.replace directly here to avoid the query params that get attached when using redirectToPage.
      this.$router.replace('find-your-bill');
    });
  }
}
</script>

<style lang="scss" type="scss" scoped>
.processing-payment {
  .gradient-panel {
    border-image-slice: 1 1 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProcessingPayment.vue